/*
 * @Description: 设备图标管理
 * @Author: wangsx
 * @Date: 2020-04-14 09:41:20
 * @LastEditors: your name
 * @LastEditTime: 2022-01-14 16:08:09
 */
/**
 * @description:
 * @param key 设备类型编号
 * @param name 设备名称
 * @param icon 阿里图标class
 * @param iconImg 设备图标图片
 */
export default {
  // 默认点位类型
  default: {
    name: "标注",
    icon: "iconshexiangtou",
    iconImg: require(`@/assets/images/map/newIcon/location.png`),
    totalType: "default"
  },
  1101: {
    name: "摄像机",
    icon: "iconshexiangtou",
    iconImg: require(`@/assets/images/map/newIcon/camera.png`),
    totalType: "camera"
  },
  1202: {
    name: "门禁",
    icon: "iconmenjin",
    iconImg: require(`@/assets/images/map/newIcon/doora.png`),
    totalType: "door"
  },
  1001: {
    name: "对讲",
    icon: "iconduijiangji",
    iconImg: require(`@/assets/images/map/newIcon/microphone.png`),
    totalType: "talkback"
  },
  1401: { name: "高压电网", icon: "icondianwangqiye", totalType: "" },
  1501: { name: "电子围栏", icon: "iconweilan" },
  2601: { name: "智能电教", icon: "iconzhengjidianjiao" },
  2701: { name: "视频会议", icon: "iconvideo-conferencing" },
  1002: {
    name: "广播",
    icon: "iconguangbo",
    iconImg: require(`@/assets/images/map/newIcon/broadcast.png`),
    totalType: "broadcast"
  },
  1301: {
    name: "紧急按钮",
    icon: "iconbutton",
    iconImg: require(`@/assets/images/map/newIcon/report.png`)
  },
  1402: { name: "红外对射", icon: "iconhongwaiduishe" },
  1403: { name: "微震动", icon: "iconzhendong" },
  1404: { name: "雷达", icon: "iconleida" },
  2901: { name: "大屏", icon: "icondaping" },
  3001: { name: "LED", icon: "iconled" },
  3101: { name: "行为分析", icon: "iconhangweifenxicopy" },
  3201: { name: "人脸识别", icon: "iconrenlianshibie" },
  3301: { name: "智能押解", icon: "iconquerenjieya" },
  3401: {
    name: "监控",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/shexiangtou.png`),
    totalType: "监控"
  },
  3402: {
    name: "人",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/ren.png`),
    totalType: "ren"
  },
  3403: {
    name: "房",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/fang.png`),
    totalType: "房"
  },
  3404: {
    name: "单位",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/danwei.png`),
    totalType: "danwei"
  },
  3405: {
    name: "安防设施",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/anfang.png`),
    totalType: "anfang"
  },
  3406: {
    name: "警员（力量）",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/liliang.png`),
    totalType: "liliang"
  },
  3407: {
    name: "装备",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/zhuangbei.png`),
    totalType: "zhuangbei"
  },
  3408: {
    name: "在线摄像头",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/shexiangtouzx.png`),
    totalType: "lixian"
  },
  3409: {
    name: "离线摄像头",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/shexiangtoulx.png`),
    totalType: "zaixian"
  },
  3410: {
    name: "红色方块",
    icon: "",
    iconImg: require(`@/assets/images/map/newIcon/fill.png`),
    totalType: "fill"
  },
  3411: {
    name: "保安",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/baoan.png`),
    totalType: "fill"
  },
  3412: {
    name: "保洁",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/baojie.png`),
    totalType: "fill"
  },
  3413: {
    name: "辅警",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/fujing.png`),
    totalType: "fill"
  },
  3414: {
    name: "民警",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/minjing.png`),
    totalType: "fill"
  },
  3415: {
    name: "绿化",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/lvhua.png`),
    totalType: "fill"
  },
  3416: {
    name: "社区",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/shequ.png`),
    totalType: "fill"
  },
  3417: {
    name: "网格员",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/wanggeyuan.png`),
    totalType: "fill"
  },
  3418: {
    name: "上报",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/shangbao.png`),
    totalType: "fill"
  },
  3419: {
    name: "外卖员",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/waimaiyuan.png`),
    totalType: "fill"
  },
  3420: {
    name: "标记点",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/fillCircle.png`),
    totalType: "fill"
  },
  3421: {
    name: "志愿者",
    icon: "",
    iconImg: require(`@/assets/images/threeSolid/zhiyuanzhe.png`),
    totalType: "fill"
  },
};